import React from 'react';
import TVArtCycler from './TVArtCycler';

/**
 * Renders the "Now Playing" artwork slot on the public TV display.
 *
 * Feb 2026 — audio-only mode: the YouTube video iframe was retired here.
 * Reasons:
 *   • Venue Wi-Fi bandwidth: hundreds of MB/hr saved per pod.
 *   • Embed reliability: enough tracks silently 404 the video iframe
 *     (regional blocks, embed-disabled) that the failure-recovery loop
 *     was hurting more than it helped.
 *   • Legal cleanliness: no video redistribution surface at all — we
 *     only stream audio via the hidden dual-driver iframes in
 *     `utils/youtubePlayer.js` (capped to `tiny` quality preset).
 *
 * Component now always renders the album-art + gallery cycler. The full
 * prop signature is retained (with unused props) so callers don't need
 * updating; the extras are simply ignored.
 */
export default function TVNowPlayingArt(props) {
  const { albumImage, portrait, gallery = [] } = props;
  return <TVArtCycler albumImage={albumImage} gallery={gallery} portrait={portrait} />;
}
